import { render, staticRenderFns } from "./Settings_Position.vue?vue&type=template&id=3cf03b98&scoped=true"
import script from "./Settings_Position.vue?vue&type=script&lang=js"
export * from "./Settings_Position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf03b98",
  null
  
)

export default component.exports